import React from 'react';
import { FaArrowLeftLong ,FaArrowRightLong } from "react-icons/fa6";

const Arrow = ({ onLeftClick, onRightClick }) => {
  return (
    <div className="flex items-center gap-4">
      <button
        onClick={onLeftClick}
        className="w-16 h-16 flex items-center justify-center rounded-full bg-transparent text-white transition cursor-pointer"
        style={{ border: '1px solid #6D6D6D' }}
      >
        <FaArrowLeftLong size={25} />
      </button>

      <button
        onClick={onRightClick}
        className="w-16 h-16 flex items-center justify-center rounded-full bg-transparent text-white transition cursor-pointer"
        style={{ border: '1px solid #F58220' }}
      >
        <FaArrowRightLong size={25} />
      </button>
    </div>
  );
};

export default Arrow;
